import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthShell from '../components/auth/AuthShell';
import RegisterForm from '../components/auth/RegisterForm';

export default function RegisterPage() {
  const { t } = useTranslation();
  return (
    <AuthShell testId="register-page">
      <h1 className="font-heading text-[22px] font-extrabold" data-testid="register-title">
        {t('register.title')}
      </h1>
      <p className="mb-5 mt-1 text-sm text-muted-foreground">
        {t('register.subtitle')}{' '}
        {t('register.haveAccount')}{' '}
        <Link to="/login" className="text-foreground underline" data-testid="register-to-login-link">
          {t('register.signIn')}
        </Link>
      </p>
      <RegisterForm />
    </AuthShell>
  );
}